import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { History } from 'history'
import * as AuthModule from '../modules/auth';
import * as WordsModule from '../modules/words';

export const createRootReducer = (history : History) => combineReducers({
    router: connectRouter(history),
    auth: AuthModule.reducer,
    words: WordsModule.reducer
});